import React from 'react';
import { motion } from "framer-motion";
import GroupImage from "../assets/benefits-enterprise-group.webp";
import Badge1 from "../assets/badge-lowers-time.png";
import Badge2 from "../assets/badge-control-connection.png";
import Badge3 from "../assets/badge-info-exchange.png";
import Badge4 from "../assets/badge-simplifies-process.png";
import Badge5 from "../assets/badge-advanced-process.png";
import Badge6 from "../assets/badge-reduce-cost.png";
import IconCloud from "../assets/icon-cloud-storage.png";
import IconAutomation from "../assets/icon-Eautomation.png";
import IconUI from "../assets/icon-user-interface.png";
import enterpriseeGrouped from '../assets/enterprise-grouped.webp';
import enterpriseGrouped from '../assets/enterprise-main-grouped.webp'; 
import { useState, useEffect,useRef } from "react";
import { useNavigate } from 'react-router-dom'; 
 
import { Helmet } from "react-helmet-async";

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.2,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};
const badgeAnimation = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  transition: {
    duration: 0.6,
    ease: "easeOut",
    repeat: Infinity,
    repeatType: "reverse",
    repeatDelay: 1,
  },
};

const features = [
  {
    title: "Cloud storage",
    description: "Cloud computing model that stores data on the Internet through a cloud computing provider",
    icon: IconCloud,
    bg: "bg-[#FFF5CC]",
  },
  {
    title: "Automation",
    description: "Systems and technology to carry out operations with little assistance increasing productivity and efficiency.",
    icon: IconAutomation,
    bg: "bg-[#F3EEFF]",
  },
  {
    title: "User interface",
    description: "Having a deep understanding of users, what they need, what they value, and their abilities.",
    icon: IconUI,
    bg: "bg-[#FFF5CC]",
  },
];

export default function EnterpriseSolutionsTopSection() {
   
  const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };
  const navigate = useNavigate();
 
  const handleClick = () => {
    navigate("/Contact#contact-section");
  };
   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isServicesOpen, setIsServicesOpen] = useState(false);
    const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
    const [isCompanyOpen, setIsCompanyOpen] = useState(false);
  
    const toggleMobileMenu = () => {
      setIsMobileMenuOpen(!isMobileMenuOpen);
    };
  
    const toggleServicesDropdown = () => {
      setIsServicesOpen(!isServicesOpen);
    };
  
    const toggleIndustriesDropdown = () => {
      setIsIndustriesOpen(!isIndustriesOpen);
    };
  
    const toggleCompanyDropdown = () => {
      setIsCompanyOpen(!isCompanyOpen);
    };


    const [isOpen, setIsOpen] = useState(false);

  const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <>
    <Helmet>
        <title>Enterprise Application Solutions | Scalable Software for Business Efficiency</title>
        <meta name="description" content="Boost your business efficiency with LENTERA’s enterprise applications. Our scalable solutions, including CRM, BI, and cloud-based systems, streamline processes, enhance automation, and improve data management for sales, finance, and customer service teams."/>
        <meta name="keywords" content="LENTERA enterprise applications, business process optimization, enterprise software development."/>
      </Helmet>
   
            <section className="w-full bg-[#F8F8F8] py-20 px-4 sm:px-6">
  <div className="w-full max-w-[1312px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
    
    {/* Left Column – 60% with animation */}
    <motion.div
      className="w-full lg:w-[60%]"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      
      <h5 className="text-[#009c3c] text-sm font-semibold uppercase mb-3 tracking-wide">
        Enterprise Application
      </h5>

      <h2 className="text-[#1E1E1E] text-[40px] md:text-[48px] font-extrabold leading-tight mb-6">
        Powering business success<br />
              with scalable solutions
      </h2>

      <p className="text-[#4A4A4A] text-base leading-relaxed max-w-[580px]">
            Enterprise applications are scalable systems that support complex business operations. They unify processes across departments for seamless coordination and efficiency.
      </p>
    </motion.div>

    {/* Right Column – 40% with animation */}
    <motion.div
      className="w-full lg:w-[40%] flex justify-center"
      initial={{ opacity: 0, x: 60 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
    >
       <img
              src={enterpriseGrouped}
              alt="Enterprise Illustration Grouped"
              className="w-full max-w-[500px] h-auto object-contain"
            />
      
    </motion.div>

  </div>
</section>

    

    <section className="w-full bg-[#F8F8F8] font-poppins">
      {/* Top Text Section */}
      

   <motion.section
      className="w-full bg-[#FDFDFD] py-16 px-4 sm:px-6 lg:px-8"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <div className="max-w-[1280px] mx-auto bg-white rounded-[32px] shadow-md px-6 sm:px-10 lg:px-16 py-12 flex flex-col lg:flex-row items-center gap-10">
        
        {/* Left Image */}
        <motion.div
          className="w-full lg:w-1/2 flex justify-center"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          viewport={{ once: true }}
        >
          <div className="w-[280px] sm:w-[320px] md:w-[360px] h-[280px] sm:h-[320px] md:h-[360px] rounded-full bg-[#D3F5FF] flex items-center justify-center">
            <img
              src={enterpriseeGrouped}
              alt="Enterprise group"
              className="h-auto max-h-[100%] object-contain"
            />
          </div>
        </motion.div>

        {/* Right Text */}
        <motion.div
          className="w-full lg:w-1/2"
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <h2 className="text-[32px] sm:text-[40px] font-extrabold text-[#1A1A1A] leading-tight mb-4">
            What is enterprise <br className="hidden sm:block" /> application?
          </h2>
          <div className="w-[80px] h-[2px] bg-[#3DBE83] mb-6"></div>
          <p className="text-[#333333] text-[16px] leading-[28px] mb-4">
            Custom development is the process of creating software specifically
            designed to meet the unique needs of a business or industry. Unlike
            off-the-shelf solutions, it builds applications tailored to fit a
            company’s workflows, goals, and challenges. This approach offers
            greater flexibility, scalability, and efficiency.
          </p>
          <p className="text-[#333333] text-[16px] leading-[28px]">
            Enterprise applications like CRM and BI help manage business
            processes efficiently. They are used in industries and departments
            such as sales, finance, and customer service.
          </p>
        </motion.div>
      </div>
    </motion.section>
      {/* Benefits Section */}
      <div className="w-full bg-[#005C4B] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 flex flex-col lg:flex-row items-center gap-12">
          {/* Image */}
          <div className="w-full max-w-[520px]">
            <img src={GroupImage} alt="Benefits Grouped" className="w-full h-auto" />
          </div>
          {/* Content */}
          <div className="flex-1 w-full">
            <h2 className="text-[32px] sm:text-[44px] leading-[1.2] font-semibold mb-4">
              Benefits of using enterprise <br /> application
            </h2>
            <p className="text-[16px] sm:text-[18px] mb-8">
              Unlock seamless efficiency and scalable growth with enterprise applications.
            </p>
            <p className="font-semibold text-[24px] sm:text-[30px] mb-6">FEATURES</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <motion.img {...badgeAnimation} src={Badge1} alt="Lowers time" className="w-full h-[56px] max-w-[372px]" />
              <motion.img {...badgeAnimation} src={Badge2} alt="Control connection" className="w-full h-[56px] max-w-[372px]" />
              <motion.img {...badgeAnimation} src={Badge3} alt="Information exchange" className="w-full h-[56px] max-w-[372px]" />
              <motion.img {...badgeAnimation} src={Badge4} alt="Simplifies processes" className="w-full h-[56px] max-w-[372px]" />
              <motion.img {...badgeAnimation} src={Badge5} alt="Advanced processes" className="w-full h-[56px] max-w-[372px]" />
              <motion.img {...badgeAnimation} src={Badge6} alt="Reduce costs" className="w-full h-[56px] max-w-[372px]" />
            </div>
          </div>
        </div>
      </div>

      {/* Key Features */}
     <section className="w-full bg-[#E9FFF6] py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-[1280px] mx-auto text-center">
        {/* Heading */}
        <motion.h2
          className="text-[32px] sm:text-[40px] font-extrabold text-[#111111] mb-3"
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          Key features
        </motion.h2>

        {/* Subheading */}
        <motion.p
          className="text-[#444444] text-[16px] sm:text-[18px] mb-12"
          variants={fadeInUp}
          custom={1}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          Discover the game-changing key features that set you apart!
        </motion.p>

        {/* Feature Cards */}
        <div className="flex flex-wrap justify-center gap-8">
          {features.map((feature, i) => (
            <motion.div
              key={i}
              className="w-full sm:w-[360px] md:w-[380px] lg:w-[402px] h-[344px] bg-white rounded-[24px] shadow-md p-6 sm:p-8 text-left flex flex-col items-start"
              variants={fadeInUp}
              custom={i + 2}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.4 }}
            >
              <div
                className={`w-full h-[100px] ${feature.bg} rounded-[16px] flex justify-center items-center mb-6`}
              >
                <img
                  src={feature.icon}
                  alt={feature.title}
                  className="w-[65px] h-[65px]"
                />
              </div>
              <h3 className="text-[20px] font-semibold text-[#111111] mb-2">
                {feature.title}
              </h3>
              <p className="text-[16px] text-[#444444]">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
    </section>
    
    </>
  );
}
